import { render, staticRenderFns } from "./SentimentInTime.vue?vue&type=template&id=05795a64&scoped=true&"
import script from "./SentimentInTime.vue?vue&type=script&lang=js&"
export * from "./SentimentInTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05795a64",
  null
  
)

export default component.exports